import React from 'react';
import classes from "./styles.module.scss";
import Title from '@/ui/Title';
import Image from '@/ui/Image';
import ArrowRight2 from "@/assets/ArrowRight2.svg";
import Link from 'next/link';

const InsightCard = ({ item }) => {
  return <Link className={classes.card} href={"/blogs/" + item.url_slug}>
    <Image className={classes.image} img={item.image} alt={item.alt_text} size="380x360" />
    <div className={classes.sector}>{item.sector}</div>
    <div className={`bg purple ${classes.content}`}>
      <Title title={item.title} tag="div" className="h6 post-title" />
      <div className={classes.more}>
        <div>Read more</div>
        <ArrowRight2 width={18} height={18} className={`fill white ${classes.icon}`} />
      </div>
    </div>
  </Link>;
}

export default InsightCard